import axios from "../../../utils/authAxios";
const api_base_url = process.env.REACT_APP_API_BASEURL + "/api/TexasGrouping";

export const getTexasGrouping = async () => {
  return axios.get(`${api_base_url}`).then((res) => {
    return res;
  });
};

// Insert New TexasGrouping
export const addTexasGrouping = async (newTexasGrouping) => {
  return axios.post(`${api_base_url}`, {
    ...newTexasGrouping,
  });
};


export const deleteTexasGrouping = async (ids) => {
  return axios.delete(`${api_base_url}`, {
    data: ids,
  });
};

export const updateTexasGrouping = async (editTexasGrouping) => {
  const formData = new FormData();
  editTexasGrouping.texasGroupingId &&
    formData.append("texasGroupingId", editTexasGrouping.texasGroupingId);
  editTexasGrouping.texasGroupingName &&
    formData.append("texasGroupingName", editTexasGrouping.texasGroupingName);
  editTexasGrouping.createdBy &&
    formData.append("createdBy", editTexasGrouping.createdBy);
  editTexasGrouping.createdDate &&
    formData.append("createdDate", editTexasGrouping.createdDate);
  editTexasGrouping.isActive !== undefined &&
    formData.append("isActive", editTexasGrouping.isActive);
  return axios.put(`${api_base_url}`, formData);
};
